import { AttributeSize, IAttributeLayout } from "../core/types/webgl_types.js";

export function generateAttributeDeclarations( layout: IAttributeLayout[] ): string
{
  return layout.map( attr => {
    let glsl_type = 'float';
    switch ( attr.size )
    {
      case AttributeSize.Vec2: glsl_type = 'vec2'; break;
      case AttributeSize.Vec3: glsl_type = 'vec3'; break;
      case AttributeSize.Vec4: glsl_type = 'vec4'; break;
    }
    const name_part = attr.name ? attr.name : `a_unknown_${attr.location}`;
    return `layout(location = ${attr.location}) in ${glsl_type} ${name_part};`;
  } ).join( '\n' );
}
